import { usePrograms } from '../use-programs';

export function useProgram(programId = '', packClass = '', circleId: number) {
    const { programs, ...otherProps } = usePrograms(
        {
            [packClass]: new Set([programId]),
        },
        circleId
    );
    return {
        program: programs?.[0]?.programs?.[0],
        ...otherProps,
    };
}
